import React from 'react'
import styled from 'styled-components'

import Animation from '../../assets/images/preloader.gif'

const Preloader = styled.img.attrs({
  src: Animation
})`
    display: flex;
    align-self: center;
    margin: auto;
`

export default () => <Preloader />
